import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"
import {getFirestore} from "firebase/firestore"
import {getStorage} from "firebase/storage"

const firebaseConfig = {
	apiKey: "AIzaSyCj_Z7-sQeVUGGrIPD-ksuVjHrGrS6pNJs",
	authDomain: "beyin-361608.firebaseapp.com",
	projectId: "beyin-361608",
	storageBucket: "beyin-361608.appspot.com",
	messagingSenderId: "437064588459",
	appId: "1:437064588459:web:1db25edbba7c78ddb0abee",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app